<div class="form-group">
  @if (label(); as label) {
    <onyx-input-label
      [variant]="variant()"
      [label]="label"
      [required]="required()"
      [disabled]="disabled()"
      [hint]="hint()"
      (click)="labelClick.emit()"
    ></onyx-input-label>
  }

  <div class="group" [style.gap.px]="gap()">
    <ng-content></ng-content>
  </div>

  <ng-content select="onyx-suggestions"></ng-content>
</div>

@if (controls() && errors()) {
  <onyx-error
    [errors]="controls()!"
    variant="control"
    [align]="errorsAlign()"
  ></onyx-error>
}
